import { Component, Input, OnInit, OnDestroy, OnChanges } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';

import { Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { getHours } from 'date-fns';

import { RoleTextPipe } from 'pipes/roletext.pipe';

import { ConfigService } from 'services/config/config.service';
import { SplashService } from 'services/splash/splash.service';
import { UserService, UserInfo } from 'services/user/user.service';

@Component({
    selector: 'app-user-info',
    styleUrls: ['userinfo.component.css'],
    templateUrl: 'userinfo.component.html',
})
export class UserInfoComponent implements OnInit, OnChanges, OnDestroy {
    private _subrelease: Subject<void> = new Subject<void>();
    private _timerHandle: number;

    greeting: string;
    username: string;
    role: string;
    SmallDisplay: boolean;
    @Input() user: UserInfo;
    @Input() showName: boolean;

    constructor(
        private configService: ConfigService,
        private mediaChange: MediaObserver,
        private userService: UserService,
        private rolePipe: RoleTextPipe
    ) {}

    ngOnChanges() {
        this.username = (this.user.FirstName || '') + ' ' + (this.user.LastName || '');
        this.role = this.rolePipe.transform(this.user.CurrentRole);
    }

    ngOnDestroy() {
        if (this._timerHandle) {
            window.clearTimeout(this._timerHandle);
        }
        this._timerHandle = null;

        this._subrelease.next();
        this._subrelease.complete();
    }

    ngOnInit() {
        const self = this;

        // Set the time of day greeting
        self.SetTimeGreeting();

        // Set up a one hour repeating timer from now to check this again.
        timer(60 * 60 * 1000)
            .pipe(takeUntil(self._subrelease))
            .subscribe(tick => {
                self.SetTimeGreeting();
            });

        self.username = (self.user.FirstName || '') + ' ' + (self.user.LastName || '');

        self.SmallDisplay = self.mediaChange.isActive('xs') || self.mediaChange.isActive('sm');

        self.mediaChange.media$.pipe(takeUntil(self._subrelease)).subscribe(media => {
            self.SmallDisplay = media.mqAlias === 'xs' || media.mqAlias === 'sm';
        });
    }

    SetTimeGreeting() {
        const self = this;

        const now = new Date();
        const hour = getHours(now);

        if ((hour >= 0 && hour <= 4) || hour >= 18) {
            self.greeting = 'Good evening';
        } else if (hour > 4 && hour < 12) {
            self.greeting = 'Good morning';
        } else if (hour >= 12 && hour < 18) {
            self.greeting = 'Good afternoon';
        }
    }

    SwitchRole(newRole: string) {
        if (!newRole) {
            return;
        }

        this.userService.SetUserCurrentRole(newRole);
    }
}
